import { Select } from 'antd';
import { getBsFromAD } from '../custom-date-selector-list/helpers';
import useAppData from '@/hooks/useAppData';

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const SelectYear: React.FC<Props> = (props) => {
  const { app } = useAppData();
  const bsStartYearStr = getBsFromAD(app?.financialEndYear);
  const bsEndYearStr = getBsFromAD(app?.financialStartYear);

  const UPPER_LIMIT = bsStartYearStr
    ? Number(bsStartYearStr.split('-')[0])
    : 2099;
  const LOWER_LIMIT = bsEndYearStr ? Number(bsEndYearStr.split('-')[0]) : 1970;

  const { value = 2055, onChange } = props;
  const nepaliYears = Array.from(
    { length: UPPER_LIMIT - LOWER_LIMIT + 1 },
    (_, index) => ({
      label: UPPER_LIMIT - index,
      value: UPPER_LIMIT - index,
    }),
  );

  return (
    <Select
      size="small"
      popupMatchSelectWidth={false}
      options={nepaliYears}
      suffixIcon={null}
      value={value}
      onChange={onChange}
      variant="borderless"
      labelRender={({ label }) => (
        <div className="tw-font-semibold tw-text-white">{label}</div>
      )}
    />
  );
};

export default SelectYear;
